var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7256 8.97105V3.41012C17.7256 2.27934 16.8057 1.35938 15.6749 1.35938H4.32504C3.19426 1.35938 2.27437 2.27934 2.27437 3.41012V8.97105C0.971406 9.28449 0 10.459 0 11.8568V16.0045C0 16.3336 0.266758 16.6004 0.59582 16.6004H2.27434V18.0414C2.27434 18.3705 2.54109 18.6372 2.87016 18.6372C3.19922 18.6372 3.46598 18.3705 3.46598 18.0414V16.6004H16.5339V18.0414C16.5339 18.3705 16.8007 18.6372 17.1298 18.6372C17.4588 18.6372 17.7256 18.3705 17.7256 18.0414V16.6004H19.4041C19.7332 16.6004 19.9999 16.3336 19.9999 16.0045V11.8568C20 10.459 19.0286 9.28449 17.7256 8.97105ZM3.46602 3.41012C3.46602 2.93645 3.85141 2.55105 4.32504 2.55105H15.6749C16.1486 2.55105 16.534 2.93645 16.534 3.41012V8.88832H14.565V7.94832C14.565 6.3909 13.298 5.12387 11.7406 5.12387H8.25949C6.70207 5.12387 5.43504 6.39094 5.43504 7.94832V8.88828H3.46602V3.41012ZM13.3734 7.94832V8.88828H6.6266V7.94832C6.6266 7.04797 7.35906 6.31551 8.25941 6.31551H11.7405C12.6409 6.31547 13.3734 7.04801 13.3734 7.94832ZM1.19164 15.4087V11.8568C1.19164 10.877 1.98871 10.08 2.96844 10.08H17.0315C18.0112 10.08 18.8083 10.877 18.8083 11.8568V15.4087H1.19164Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureBedroom);
export default __webpack_public_path__ + "static/media/feature-bedroom.437436ba61f4d9697158b4e47daab774.svg";
export { ForwardRef as ReactComponent };